import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { FeeSummary } from '../models/fee-summary';
import { AppSettings } from '../../../../utils/app-settings';

@Injectable({
  providedIn: 'root'
})
export class FeesService {

  constructor(private http: HttpClient) { }
  private upcomigFeeInstallment: ReplaySubject<FeeSummary> = new ReplaySubject<FeeSummary>();
  public upcomigFeeInstallment$ = this.upcomigFeeInstallment.asObservable();

  getFeeInstallments(): Observable<Array<FeeSummary>> {
    return this.http.get<Array<FeeSummary>>(AppSettings.apiUrl + "fees");
  }

  getPaymentUrl(paymentGroupName: string): Observable<string> {
    return this.http.get<string>(AppSettings.apiUrl + "fees/" + paymentGroupName);
  }

  changeUpcomingFeeInstallment(fee: FeeSummary) {
    this.upcomigFeeInstallment.next(fee);
  }

  subscribeToUpcomigFeeInstallment(): Observable<FeeSummary> {
    return this.upcomigFeeInstallment$;
  }
}
